import { render, staticRenderFns } from "./ModelViewer.vue?vue&type=template&id=f9be1632&scoped=true&"
import script from "./ModelViewer.vue?vue&type=script&lang=js&"
export * from "./ModelViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9be1632",
  null
  
)

export default component.exports